import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import BaseComponent from 'foundation/base-component';
import store from 'general/js/store';
import FullSizeHeroBanner from './full-size-hero-banner';

class FullSizeHeroBannerComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        ReactDOM.render(
            <Provider store={store}>
                <FullSizeHeroBanner options={this.options} />
            </Provider>,
            this.element
        );
    }
}

export default FullSizeHeroBannerComponent;
